import * as React from 'react';

function SvgHelpStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 26.7C8.538 26.7 3.3 21.462 3.3 15 3.3 8.538 8.538 3.3 15 3.3c6.462 0 11.7 5.238 11.7 11.7 0 6.462-5.238 11.7-11.7 11.7zm0-1.4c5.688 0 10.3-4.611 10.3-10.3 0-5.689-4.612-10.3-10.3-10.3C9.31 4.7 4.7 9.311 4.7 15c0 5.689 4.611 10.3 10.3 10.3zm.634-7.884c-.01-.529.035-.896.133-1.1.098-.206.35-.477.755-.814.784-.652 1.296-1.167 1.535-1.545.24-.378.359-.78.359-1.203 0-.766-.326-1.437-.978-2.013-.651-.577-1.529-.865-2.632-.865-1.048 0-1.894.285-2.54.854-.644.57-.992 1.263-1.042 2.079l1.764.218c.123-.57.349-.993.677-1.271.328-.278.736-.417 1.224-.417.505 0 .908.133 1.206.4.299.266.448.586.448.96 0 .27-.084.515-.253.739-.11.14-.444.44-1.005.895-.56.456-.934.866-1.121 1.23-.187.365-.28.83-.28 1.395l.006.458h1.744zM15.81 20v-1.92h-1.92V20h1.92z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgHelpStroke;
